export default __webpack_public_path__ + "static/media/DSC01198.682ddf38.webp";